module.exports = __webpack_public_path__ + "static/media/short-07.1812df37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/short/short-07.png
// module id = 2119
// module chunks = 0